import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/local-signer-goal/local-signer-goal.yml';

import { LocalSignerGoalComponent } from './LocalSignerGoal';

// Experimental: placeholders are bundled with the component until the copy is locked.
export const LocalSignerGoal = withI18nPlaceholders(I18N_PLACEHOLDERS, LocalSignerGoalComponent);
